import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor() { }

  /**
   * Params local storage service
   * @param {string}key
   */
  public clearLocalStorage(userType: string): void {
    localStorage.removeItem(userType);
    localStorage.clear()
  }

  /**
   * Sets token
   * @param token 
   */

  set(key: string, value: string): void {
    // const data = environment.ENCRYPT_LOCAL_STORAGE ? CryptoJS.AES.encrypt(JSON.stringify(value), environment.LOCAL_STORAGE_SECRET).toString() : JSON.stringify(value);
    // localStorage.setItem(key, data);
    const data = typeof value === 'string' ? value : JSON.stringify(value);
    const storedValue = environment.ENCRYPT_LOCAL_STORAGE 
      ? CryptoJS.AES.encrypt(data, environment.LOCAL_STORAGE_SECRET).toString()
      : data;
    localStorage.setItem(key, storedValue);
  }

  /**
   * Gets token
   * @returns token 
   */
  // get(key: string): string | null {
  //   if (!localStorage.getItem(key)) return null;
  //   const data = environment.ENCRYPT_LOCAL_STORAGE ? CryptoJS.AES.decrypt(localStorage.getItem(key)!, environment.LOCAL_STORAGE_SECRET).toString(CryptoJS.enc.Utf8) : localStorage.getItem(key)!;
  //   return JSON.parse(data);
  // }
  get(key: string): string | null {
    const item = localStorage.getItem(key);
    if (!item) return null;
  
    const decryptedData = environment.ENCRYPT_LOCAL_STORAGE 
      ? CryptoJS.AES.decrypt(item, environment.LOCAL_STORAGE_SECRET).toString(CryptoJS.enc.Utf8)
      : item;
  
    // Try parsing as JSON only if it starts with { or [
    try {
      if (decryptedData.trim().startsWith('{') || decryptedData.trim().startsWith('[')) {
        return JSON.parse(decryptedData);
      }
      // If not JSON, return the string directly
      return decryptedData;
    } catch {
      // If parsing fails, return the string directly
      return decryptedData;
    }
  }
  /**
   * Removes token
   * @returns  
   */
  remove(key: string) {
    return localStorage.removeItem(key);
  }

}
